import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

const CACHE_KEY = "index-boot-cache-v5";
const CACHE_TTL_MS = 15 * 60 * 1000;

interface IndexBootData {
  leaderboard: {
    real: any[];
    npc: any[];
  };
  spotlight: {
    real: any[];
    npc: any[];
  };
  onlineCount: number;
}

function readCache(): IndexBootData | undefined {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return undefined;
    const parsed = JSON.parse(raw) as IndexBootData & { cachedAt?: number };
    if (parsed.cachedAt && Date.now() - parsed.cachedAt > CACHE_TTL_MS) return undefined;
    return parsed as IndexBootData;
  } catch {
    return undefined;
  }
}

function writeCache(data: IndexBootData) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify({ ...data, cachedAt: Date.now() }));
  } catch {}
}

export function useIndexBoot() {
  return useQuery<IndexBootData>({
    queryKey: ["index-boot"],
    queryFn: async () => {
      const cached = readCache();
      if (cached) return cached;

      const { data, error } = await supabase.functions.invoke("index-boot");
      if (error) throw error;
      const result = data as IndexBootData;
      writeCache(result);
      return result;
    },
    placeholderData: readCache,
    staleTime: CACHE_TTL_MS,
    refetchOnWindowFocus: false,
  });
}
